export default {
  "1": {
    text: "Weshalb suchen Sie einen Zahnarzt?",
    type: "checkbox",
    options: [
      {
        value: "Schmerzen/Beschwerden",
        checkName: "Schmerzen/Beschwerden Zahn/Kiefer",
        icon: {
          src: "colored/icon_zahnbehandlung.svg",
          size: "large",
        },
      },
      {
        value: "Prüfung meines Behandlungsplans",
        icon: {
          src: "colored/icon_zahnarzt_zweite_meinung.svg",
          size: "large",
        },
      },
      {
        value: "Zahnersatz",
        icon: {
          src: "colored/icon_zahnarzt_termine.svg",
          size: "large",
        },
      },
      {
        value: "Professionelle Zahnreinigung",
        icon: {
          src: "colored/icon_profi_zahnreinigung.svg",
          size: "large",
        },
      },
      {
        value: "Kosmetische Behandlung",
        checkName: "Kosmetische Behandlung Zahn",
        icon: {
          src: "colored/icon_zahnheilkunde.svg",
          size: "large",
        },
      },
      {
        value: "Vorsorgetermin",
        checkName: "Vorsorgetermin Zahn",
        icon: {
          src: "colored/icon_ort_farbig.svg",
          size: "large",
        },
      },
      {
        value: "Zweite Meinung einholen",
        checkName: "Zweitmeinung Zahn/Kiefer",
        icon: {
          src: "colored/icon_zahnarzt_zweite_meinung.svg",
          size: "large",
        },
      },
      {
        value: "Brauche einen Kieferorthopäden",
        icon: {
          src: "colored/icon_orthopaedie.svg",
          size: "large",
        },
        action: "showOrthodonticsModal",
      },
    ],
    info: `
      <p><b>Professionelle Zahnreinigung (Prophylaxe):</b><br>
      Auch wenn Sie noch so gut putzen, einige Stellen erreichen Sie zu Hause vor dem Spiegel einfach nie. Bei der professionellen Zahnreinigung werden alle Ihre Zähne, Zahnzwischenräume und auch die Bereiche ein wenig unterhalb des Zahnfleischrandes gereinigt und alle Beläge, also Plaque und Zahnstein, entfernt. Auch dunkle Verfärbungen und Ablagerungen werden dadurch reduziert. Empfohlen wird sie 2 mal jährlich und dauert ca. 1 Stunde. 
      </p>
      <p><b>Kosmetische Zahnbehandlung:</b><br>
      Bleaching, Behebung leichter Zahnfehlstellungen (Invisalign) durch Zahnschienen oder Veneers zählen meist zu kosmetischen Behandlungsmethoden. Nicht jede ist über die Krankenversicherung abrechenbar. Gerne hilft Ihnen die ARAG dabei, sich in dem Dschungel zurecht zu finden. 
      </p>
      <p><b>Zahnfehlstellungen / Kieferorthopädie:</b><br>
      Für die Behebung von Zahnfehlstellungen gibt es mittlerweile viele verschiedene Behandlungsmethoden. Nicht jede ist über die Krankenversicherung abrechenbar. Gerne hilft Ihnen die ARAG dabei, sich in dem kieferorthopädischen Dschungel zurecht zu finden. 
      </p>
      <p><b>Kontrolltermin:</b><br>
      Lassen Sie Zahnprobleme erst gar nicht entstehen und gehen Sie regelmäßige zur Kontrolle. Die Häufigkeit ist abhängig von der Anfälligkeit für Karies oder Parodontitis, sollte allerdings mindestens ein Mal im Jahr erfolgen.
      </p>
      <p><b>Zweite Meinung:</b><br>
      Hier schaut sich zusätzlich zu dem Arzt, bei dem Sie schon in Behandlung sind, auch noch ein weiterer Arzt Ihre Diagnose bzw. bevorstehende Behandlung an. Für ein sicheres Gefühl und Ihre bestmögliche Genesung.  
      </p>
    `,
  },
};
